import type { PiralPlugin } from 'piral-core'
import { trackGoal } from './plausible'
import type { PiletAnalyticsApi } from './types'

export type { PiletAnalyticsApi, GoalProps } from './types'

/**
 * Piral plugin that puts `trackGoal` on every pilet's API.
 *
 * Same ownership rule as telemetry: a pilet never touches `window.plausible`
 * itself. Handing out one function is what keeps the consent gate real — a pilet
 * cannot reach past it, cannot re-point the script, and cannot start beaconing
 * before a decision has been made.
 */
export function createAnalyticsApi (): PiralPlugin<PiletAnalyticsApi> {
  return () => ({
    trackGoal,
  })
}
